/* eslint-disable import/no-named-as-default-member */
import React from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import styled from "styled-components";
import { Button, Grid } from "@material-ui/core";
import { Add, GetApp, Repeat } from "@material-ui/icons";
import { compose } from "redux";
import loanStatuses from "../../../../constants/loanStatuses";
import dealStatuses from "../../../../constants/status";
import loanSeniorityTypes from "../../../../constants/loanSeniorityTypes";
import { addLoan, downloadQuotes, downloadQuotesAsGuest } from "../../../../store/state/loan/loan";
import { getDealName } from "../../../../store/state/deal";
import BreadCrumbGrid from "../../../Global/BreadCrumb/BreadCrumbGrid";
import dealStages from "constants/dealStages";

const LOANBOSS_BLUE = "#2196f3";

const NewButton = styled(Button)`
  && {
    margin-left: 4px;
    padding: 8px 8px 8px 2px;
    border-radius: 0;
    color: #2196f3;
    background: none;
  }
  & span {
    margin-left: 4px;
  }
  &&:hover {
    background: #f6f6f6;
  }
`;

const VerticalDivider = styled.div`
  height: 24px;
  border-right: 1px solid #cccccc;
`;

const StyledActionButton = styled(Button)`
  && {
    margin-left: 4px;
    padding: 8px 8px 8px 2px;
    border-radius: 0;
    color: #2196f3;

    background: none;
  }
  &&:hover {
    background: none;
  }
`;

const ExportButton = props => {
  return (
    <>
      <NewButton
        onClick={() => {
          props.downloadDealQuotes({
            loanStatusIds: [loanStatuses.QUOTE, loanStatuses.REJECTED_QUOTE, loanStatuses.PASSED_QUOTE],
            dealId: props.dealId,
            columns: ["amount", "ltvAsIs", "loanTermMonths", "amortizationTerm", "loanSpread", "lenderId", "indexId", "loanTypeId"],
            page: 1,
            pageSize: 100
          });
        }}
      >
        <GetApp />
        <span>EXPORT</span>
      </NewButton>
    </>
  );
};

class PipelineDealHeader extends React.Component {
  componentDidMount() {
    this.props.getDealName({ dealId: this.props.dealId, subKey: this.props.dealId });
  }

  addNewQuote = () => {
    const { history } = this.props;
    const newQuote = {
      loan: {
        dealId: this.props.dealId,
        loanStatusId: loanStatuses.QUOTE,
        loanSeniorityId: this.props.deal.dealStatusId === dealStatuses.ADDING_SUPPLEMENTAL ? loanSeniorityTypes.SUPPLEMENTAL : loanSeniorityTypes.SENIOR
      },
      callback: () => {
        history.push(`/loan/${this.props.dealId}/${this.props.savedLoan.id}`);
      }
    };

    this.props.addLoan(newQuote);
  };

  hasMultipleViews = () => {
    if(!this.props.deal.dealStatus) return false;
    let myStatus = this.props.deal.dealStatus.id;
    return myStatus === dealStatuses.REFINANCE ||
            myStatus === dealStatuses.MODIFYING ||
            myStatus === dealStatuses.ADDING_SUPPLEMENTAL;
  }

  render() {
    const { deal, dealId, dealMap, guestPermissions, authentication } = this.props;

    if(!deal) return null;
    return (
      <>
        {!authentication.isGuest && (
          <BreadCrumbGrid>
            <Link to="/pipeline/">Pipeline</Link> / {dealMap[dealId] ? dealMap[dealId].name : "\u2014"}
            {this.hasMultipleViews() && <a href={`/portfolio/funds/free/deals/${this.props.deal.id}`}><Repeat style={{color: LOANBOSS_BLUE, cursor: "pointer", marginBottom: '-5px', marginLeft: "10px" }}/></a>}
          </BreadCrumbGrid>
        )}
        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={16} style={{ marginTop: "10px", marginBottom: "10px" }}>
          <Grid item>
            <div className="title-component">Quotes</div>
          </Grid>
          {(!deal.stageId || (deal.stageId && deal.stageId !== dealStages.IN_CLOSING)) && deal.dealStatusId  && deal.dealStatusId !== dealStatuses.MODIFYING && (!authentication.isGuest || (authentication.isGuest && guestPermissions.canEdit)) && (
            <>
              <Grid item>
                <StyledActionButton variant="contained" onClick={this.addNewQuote} id="newQuoteButton">
                  <Add />
                  New Quote
                </StyledActionButton>
              </Grid>
              <Grid>
                <VerticalDivider />
              </Grid>
            </>
          )}
          {deal.dealStatusId && deal.dealStatusId !== dealStatuses.MODIFYING && (
            <Grid item>
              <ExportButton dealId={dealId} downloadDealQuotes={authentication.isGuest ? this.props.downloadQuotesAsGuest : this.props.downloadQuotes} />
            </Grid>
          )}
        </Grid>
      </>
    );
  }
}

const mapStateToProps = ({ deal, authentication, loan }) => ({
  dealMap: deal.dealNames,
  authentication,
  savedLoan: loan.editLoan && loan.editLoan.data ? loan.editLoan.data : null
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getDealName,
    downloadQuotes,
    downloadQuotesAsGuest,
    addLoan
  })
)(PipelineDealHeader);
